import { useRequiredContext } from "@redotech/react-util/context";
import { RedoMerchantClientContext } from "@redotech/redo-merchant-app-common/client/context";
import { RedoMerchantRpcClientContext } from "@redotech/redo-merchant-app-common/rpc-client";
import {
  ExpandedConversation,
  MinimalConversation,
} from "@redotech/redo-model/conversation";
import { useCallback, useEffect, useState } from "react";
import { ConversationValidationResult } from "../context/conversation-close-validation-context";
import { validateConversationCanClose } from "../utils";

export const useConversationCloseValidation = (
  conversation: MinimalConversation | ExpandedConversation,
) => {
  const client = useRequiredContext(RedoMerchantClientContext);
  const rpcClient = useRequiredContext(RedoMerchantRpcClientContext);
  const [validationResult, setValidationResult] =
    useState<ConversationValidationResult | null>(null);
  const [isValidating, setIsValidating] = useState(false);

  const validateConversation = useCallback(
    async (conversationId: string) => {
      setIsValidating(true);
      try {
        const result = await validateConversationCanClose(
          rpcClient,
          conversationId,
          conversation.team,
          client,
        );
        setValidationResult(result);
      } catch (error) {
        console.error("Failed to validate conversation can close:", error);
        setValidationResult({ canClose: true, missingTagGroups: [] });
      } finally {
        setIsValidating(false);
      }
    },
    [rpcClient, conversation, client],
  );

  useEffect(() => {
    void validateConversation(conversation._id);
  }, [conversation._id, conversation.tagIds, validateConversation]);

  return { validationResult, isValidating, revalidate: validateConversation };
};
